export default __webpack_public_path__ + "static/media/el_3.c6959093.mp3";